import Script from 'next/script';

import { ISbStoryData } from 'storyblok-js-client';

import { ExpertStoryblok, Locales } from '@monoimin/sb-types';

import { getExpertPersonSchemaByStory } from '../utils/getExpertPersonSchemaByStory';

interface PersonSchemaProps {
  expert: ISbStoryData<ExpertStoryblok>;
  locale: Locales;
  site?: MiniSlug;
}
export function ExpertPersonSchema({
  locale,
  expert,
  site,
}: PersonSchemaProps) {
  return (
    <Script id='person-jsonld' type='application/ld+json'>
      {JSON.stringify(
        getExpertPersonSchemaByStory(
          expert?.content,
          expert?.slug,
          locale,
          site
        )
      )}
    </Script>
  );
}

export default ExpertPersonSchema;
